import { renderEthos } from './Ethos.js';

export function renderInquiryTerminal() {
  return `
    <footer id="contact" class="cv-auto bg-[#050505] text-stark pt-20 md:pt-28 pb-12 px-6 lg:px-16 border-t border-[#1C201E] relative">
      <div class="max-w-7xl mx-auto">
        <!-- Philosophy Pillars Row (4-Pillar Ethos: THINK, BUILD, BREAK, SHIP) -->
        ${renderEthos()}

        <!-- Big Call to Action & Intake Terminal -->
        <div class="my-16 sm:my-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div class="lg:col-span-7">
            <div class="font-mono text-xs text-neutral-400 uppercase tracking-widest mb-3 flex flex-wrap items-center gap-2">
              <span class="text-white font-medium">SOFTWARE · WEB · GRAPHICS · GAME DEVELOPMENT</span>
              <span class="text-neutral-600 hidden sm:inline">•</span>
              <span class="text-neutral-400">BUILDING FROM SRI LANKA / LEARNING WORLDWIDE</span>
            </div>
            <span class="font-mono text-xs text-neutral-500 uppercase tracking-widest block mb-4">THE NEXT SYSTEM STARTS WITH AN IDEA.</span>
            <h2 class="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-stark leading-[0.95] font-display">
              <span class="sr-only">Contact &amp; Project Inquiry Terminal — </span>
              Let's make <br/>
              something <br/>
              <span class="font-serif italic font-normal text-amber-100">worth remembering.</span>
            </h2>
            <p class="font-mono text-xs text-neutral-400 mt-6 max-w-lg leading-relaxed font-light">
              Submit your project specifications, experiment concepts, or inquiries below. Dispatches are transmitted directly to <span class="text-white font-medium">ranjikaneth2005@gmail.com</span> with a 24–48 hour response SLA.
            </p>
          </div>

          <!-- Editorial Inquiry Receipt Card with Formspree Form -->
          <div class="lg:col-span-5 bg-sand-sheet text-black p-7 sm:p-8 rounded-none relative border border-black/15 shadow-2xl">
            <div class="flex justify-between items-center border-b border-black/15 pb-3.5 mb-5 font-mono text-[11px]">
              <span class="font-bold uppercase tracking-widest text-neutral-900">PROJECT INTAKE / OPEN</span>
              <span class="relative flex h-3 w-3 items-center justify-center">
                <span class="absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75 animate-ping"></span>
                <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-600 terminal-beacon-green"></span>
              </span>
            </div>

            <!-- Formspree Integration Form -->
            <form 
              id="intake-terminal-form" 
              action="https://formspree.io/f/xrpgyane" 
              method="POST" 
              class="space-y-3.5 font-mono text-xs"
            >
              <input type="hidden" name="_subject" value="Project Inquiry from Portfolio - Ranjika Nethpriya" />

              <div>
                <label class="text-neutral-700 uppercase text-[10px] font-semibold tracking-wider block mb-1 flex justify-between items-center">
                  <span>01 // YOUR EMAIL *</span>
                  <span class="text-[9px] text-neutral-500 font-normal">SLA: 24–48H</span>
                </label>
                <input 
                  type="email" 
                  name="email" 
                  required 
                  placeholder="alex@organization.domain" 
                  class="w-full bg-white/90 text-black placeholder-neutral-400 px-3 py-2 rounded-none border border-black/20 focus:border-black focus:bg-white focus:outline-none transition-colors text-xs font-mono"
                />
              </div>

              <div>
                <label class="text-neutral-700 uppercase text-[10px] font-semibold tracking-wider block mb-1 flex justify-between items-center">
                  <span>02 // INQUIRY SCOPE</span>
                  <span class="text-[9px] text-neutral-500 font-normal">WEB · GRAPHICS · GAME DEV · CUSTOM</span>
                </label>
                <input 
                  type="text" 
                  name="scope" 
                  placeholder="e.g. WebGL Shaders, Godot Game, Full-Stack Web App..." 
                  class="w-full bg-white/90 text-black placeholder-neutral-400 px-3 py-2 rounded-none border border-black/20 focus:border-black focus:bg-white focus:outline-none transition-colors text-xs font-mono"
                />
              </div>

              <div>
                <label class="text-neutral-700 uppercase text-[10px] font-semibold tracking-wider block mb-1">
                  <span>03 // BRIEF / DETAILS *</span>
                </label>
                <textarea 
                  name="message" 
                  required 
                  rows="3" 
                  placeholder="Outline your concept, objectives, or timeline..." 
                  class="w-full bg-white/90 text-black placeholder-neutral-400 p-2.5 rounded-none border border-black/20 focus:border-black focus:bg-white focus:outline-none transition-colors text-xs font-mono resize-none leading-relaxed"
                ></textarea>
              </div>

              <!-- Metadata Row -->
              <div class="grid grid-cols-2 gap-3 pt-2.5 border-t border-black/10 text-[10px] text-neutral-700">
                <div>
                  <span class="text-neutral-500 uppercase text-[9px] block">DISPATCH TARGET</span>
                  <span class="font-semibold text-neutral-900 truncate block" title="ranjikaneth2005@gmail.com">ranjikaneth2005@gmail.com</span>
                </div>
                <div>
                  <span class="text-neutral-500 uppercase text-[9px] block">WORK MODE</span>
                  <span class="font-semibold text-neutral-900">REMOTE / WORLDWIDE</span>
                </div>
              </div>

              <button 
                type="submit" 
                id="intake-submit-btn" 
                class="mt-3 block w-full text-center bg-black text-stark py-3 font-mono text-xs uppercase tracking-widest font-bold hover:bg-ember hover:text-white transition-colors duration-150 rounded-none shadow-none cursor-pointer flex items-center justify-center gap-2 group"
              >
                <span>DISPATCH INQUIRY</span>
                <span class="group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform text-neutral-400 group-hover:text-white">↗</span>
              </button>

              <!-- Real-time Feedback Status Box -->
              <div id="intake-status-feedback" class="hidden mt-2 p-2.5 text-center font-mono text-[11px]"></div>
            </form>
          </div>
        </div>

        <!-- Social Index Links -->
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 py-7 border-y border-[#1C201E] font-mono text-xs">
          <a class="group flex items-center justify-between text-neutral-400 hover:text-stark transition-colors py-1" href="https://github.com/Ranjika123" target="_blank" rel="noopener noreferrer">
            <span>01 // GITHUB</span>
            <span class="group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform text-neutral-500 group-hover:text-ember">↗</span>
          </a>
          <a class="group flex items-center justify-between text-neutral-400 hover:text-stark transition-colors py-1" href="https://www.linkedin.com/in/ranjika-nethpriya" target="_blank" rel="noopener noreferrer">
            <span>02 // LINKEDIN</span>
            <span class="group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform text-neutral-500 group-hover:text-ember">↗</span>
          </a>
          <a class="group flex items-center justify-between text-neutral-400 hover:text-stark transition-colors py-1" href="https://www.instagram.com/ranjika_neth/" target="_blank" rel="noopener noreferrer">
            <span>03 // INSTAGRAM</span>
            <span class="group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform text-neutral-500 group-hover:text-ember">↗</span>
          </a>
          <a class="group flex items-center justify-between text-neutral-400 hover:text-stark transition-colors py-1" href="https://web.facebook.com/ranjikaneth/" target="_blank" rel="noopener noreferrer">
            <span>04 // FACEBOOK</span>
            <span class="group-hover:translate-x-1 group-hover:-translate-y-0.5 transition-transform text-neutral-500 group-hover:text-ember">↗</span>
          </a>
        </div>

        <!-- Colophon and Bottom Copyright Bar -->
        <div class="pt-8 flex flex-col sm:flex-row items-center justify-between font-mono text-[10px] text-neutral-500 tracking-wider select-none">
          <div>
            <span>SOFTWARE · WEB · GRAPHICS · GAME DEVELOPMENT</span>
          </div>
          <div class="mt-2 sm:mt-0 text-neutral-500">
            <span>RANJIKA NETHPRIYA © 2026 — ALL RIGHTS RESERVED</span>
          </div>
        </div>
      </div>
    </footer>
  `;
}

export function initInquiryTerminal() {
  const form = document.getElementById('intake-terminal-form');
  const btn = document.getElementById('intake-submit-btn');
  const feedback = document.getElementById('intake-status-feedback');

  if (!form || !btn || !feedback) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    btn.disabled = true;
    btn.innerHTML = `<span>DISPATCHING...</span> <span class="animate-pulse">●</span>`;
    feedback.className = "hidden";

    try {
      const formData = new FormData(form);
      const res = await fetch("https://formspree.io/f/xrpgyane", {
        method: "POST",
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (res.ok) {
        feedback.className = "mt-2 p-2.5 text-center font-mono text-[11px] border border-emerald-600/50 bg-emerald-950/15 text-emerald-900 font-bold block";
        feedback.innerHTML = `✔ INQUIRY TRANSMITTED // 24-48H RESPONSE SLA ACTIVATED`;
        btn.innerHTML = `<span>INQUIRY SENT</span> <span>✔</span>`;
        form.reset();
      } else {
        const errorData = await res.json();
        const msg = errorData.errors ? errorData.errors.map(err => err.message).join(", ") : "Transmission failed";
        throw new Error(msg);
      }
    } catch (err) {
      feedback.className = "mt-2 p-2.5 text-center font-mono text-[11px] border border-red-600/50 bg-red-950/15 text-red-900 font-bold block";
      feedback.innerHTML = `✕ ERROR: ${err.message || 'Transmission failed'}. Please retry or mail directly.`;
      btn.disabled = false;
      btn.innerHTML = `<span>RETRY DISPATCH</span> <span>↗</span>`;
    }
  });
}
